<template>
  <div class="ma-2 ml-3 site_content">
    <div class="tab-container flex">
        <div class="tab-content">
          <button class="tab mr-1" 
            :class="{ active: selectedTab === 'space' }" 
            @click="selectTab('space')">
            시설
          </button>
          <button class="tab mr-1"
            :class="{ active: selectedTab === 'user' }" 
            @click="selectTab('user')">
            사용자
          </button>
          <button class="tab"
            :class="{ active: selectedTab === 'deal' }" 
            @click="selectTab('deal')">
            거래처
          </button>
        </div>
      </div>

    <div class="flex" v-if="selectedTab == 'space'">
      <div>
        <RegisterSpace />
      </div>

    </div>

    <div v-if="selectedTab == 'user'">
      <div>
        <RegisterUser />
      </div>
    </div>

    <div v-if="selectedTab == 'deal'">
      <div>
        <RegisterDealCompany />
      </div>
    </div>

  </div>
</template>

<script>
import Apis from '@/api/apis';
import RegisterUser from "@/views/info/info_set/user.vue";
import RegisterDealCompany from "@/views/info/info_set/dealCompany.vue";
import RegisterSpace from "@/views/info/info_set/infoSpace.vue";

export default {
  name: 'infoSet',
  components:{
    RegisterUser,
    RegisterDealCompany,
    RegisterSpace
  },
  async created(){
    Apis.pageCount({ //페이지뷰 카운터
      page_name: this.$route.name,
      url: this.$route.path,
      division: "locgov",
    },() => {  // 정상처리
    // console.log("pageCount 호출",res);
    }).catch( (err) => {  // 개별 API 오류 처리 예제
      console.log("pageCount 호출 오류",err);
    });
  },
  data(){
    return{
      selectedTab: 'space',
    }
  },
  methods:{
    selectTab(value) {
      this.selectedTab = value;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../info/info_style/info_style.scss";
// @import '../../style/base.scss';
.tab-container{
  // justify-content: end;
  align-items: center;
}
.tab-content {
  display: inline-flex;
  padding:5px;
  background-color: #F3F3F3;
  border-radius: 5px;
  overflow: hidden; /* 버튼이 탭 영역을 넘지 않도록 */
  height: 50px;
}

.tab {
  flex: 1;
  width:120px;
  font-size:16px !important;
  font-weight:600 !important;

  border-radius: 20px;
  border: none;
  background-color: #e7e7e7;
  color: #bababa; 
  cursor: pointer;
  transition: all 0.5s ease;
}

.tab.active {
  background-color: $point-color; 
  color: white;
  font-weight:600;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2); 
}

.tab:not(.active):hover {
  background-color: #f0f0f0; 
}
</style>